import React from 'react';

/**
 * StubPage — Platzhalter fuer Pages die in Block 3 portiert werden.
 * Hat absichtlich Hinweis auf den naechsten Migrations-Block.
 */
export default function StubPage({ icon = '🚧', title, description }) {
  return (
    <div className="stub-card">
      <div className="stub-icon">{icon}</div>
      <div className="stub-title">{title}</div>
      <div className="stub-desc">{description}</div>
    </div>
  );
}
